import { createFileRoute } from "@tanstack/react-router";
import UkTerms from "@/pages/legal/UkTerms";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fr/terms/")({
  head: () => routeHead("/fr/terms/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkTerms />
  );
}
